import React, { FC } from "react";
import type { SolutionsHeroProps } from "@/types";
import { TextCols } from "../text-cols";

export const SolutionsHero: FC<SolutionsHeroProps> = ({
  label,
  title,
  description,
}) => {
  return (
    <section className="solutionsHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description,
          }}
          maxTitleWidth={937}
          singleCol
        />
      </div>
    </section>
  );
};
